exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pitchreadiness-js": () => import("./../../../src/pages/pitchreadiness.js" /* webpackChunkName: "component---src-pages-pitchreadiness-js" */),
  "component---src-pages-readinessrating-js": () => import("./../../../src/pages/readinessrating.js" /* webpackChunkName: "component---src-pages-readinessrating-js" */)
}

